import React from "react";
import { Dropdown } from "./Dropdown";
import { DatePicker } from "./DatePicker";
import { DateRange } from "./DateRange";
import { Autocomplete } from "./Autocomplete";
import { PasswordInput } from "./Password";
import { TextInput } from "./Input";
import { Control as FormControl } from "./Control";
import { SearchInput } from "./Search";
import { DropdownAutocomplete } from "./DropdownAutocomplete";
import { InputAutocomplete } from "./InputAutocomplete";
import { FileInput } from "./FileInput";
import { DirectoryInput } from "./DirectoryInput";

const getInputByType = type => {
  switch (type) {
    case "password": {
      return PasswordInput;
    }
    case "search": {
      return SearchInput;
    }
    case "file": {
      return FileInput;
    }
    case "directory": {
      return DirectoryInput;
    }

    default: {
      return TextInput;
    }
  }
};

FormControl.Dropdown = props => {
  const isLabelAndPropsDifferent =
    props?.label && props?.placeholder && props?.label !== props?.placeholder;
  const isDefaultValueSelected =
    props?.values?.length && props?.input?.value !== "";
  const forceLabel = Boolean(
    isLabelAndPropsDifferent || isDefaultValueSelected
  );
  return (
    <FormControl
      {...props}
      type="dropdown"
      forceLabel={forceLabel}
      Component={Dropdown}
    />
  );
};

FormControl.DatePicker = props => (
  <FormControl {...props} Component={DatePicker} />
);

FormControl.DateRange = props => (
  <FormControl {...props} Component={DateRange} />
);

FormControl.Autocomplete = props =>
  props.type === "dropdown" ? (
    <FormControl {...props} Component={DropdownAutocomplete} />
  ) : (
    <FormControl {...props} Component={Autocomplete} />
  );

FormControl.Input = props => {
  const forceLabel = props.type === "file" || props.forceLabel;
  return (
    <FormControl
      {...props}
      forceLabel={forceLabel}
      Component={getInputByType(props.type)}
    />
  );
};

FormControl.InputAutocomplete = props => (
  <FormControl {...props} Component={InputAutocomplete} />
);

FormControl.Dropdown.propTypes = Dropdown.propTypes;
FormControl.Input.propTypes = TextInput.propTypes;
FormControl.Autocomplete.propTypes = Autocomplete.propTypes;
FormControl.InputAutocomplete.propTypes = InputAutocomplete.propTypes;

const CompoundFormControl = FormControl;

export {
  Dropdown,
  DatePicker,
  DateRange,
  Autocomplete,
  TextInput,
  PasswordInput,
  CompoundFormControl as FormControl,
  SearchInput,
};
